@import '../../styles/buttons.css';

:host {
  display: block;
  width: 100%;
  font-family: Helvetica, Arial, sans-serif;
  position: relative;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  padding: 10px;
  gap: 10px;
}

.header .account {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.account-link {
  background-color: var(--tambr-accent-color, #000000);
  color: #ffffff;
  border: 0;
  transition: all .2s;
}

.account-link:hover {
  background-color: var(--tambr-accent-color, #000000);
  color: #ffffff;
  opacity: 0.8;
}

.month-switch {
  text-align: end;
  display: inline-flex;
  align-items: center;
  margin-left: auto;
}

.month-label {
  font-weight: 400;
  text-transform: uppercase;
  font-size: 14px;
  width: 60px;
  text-align: center;
  letter-spacing: 0.8px;
}

.dates-row {
  display: flex;
  position: relative;
  gap: 5px;
  align-items: center;
  padding: 0 5px 0px;
}

.dates-row .days-container {
  flex: 1;
  display: flex;
  gap: 2px;
  align-items: center;
}

.dates-row .date-button {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px 2px;
  background-color: transparent;
  border: none;
  gap: 5px;
  cursor: pointer;
  border-radius: 5px;
  transition: background-color .2s ease-in-out;
}

.dates-row .date-button:hover {
  background-color: #efefef;
}

.dates-row .date-button.selected .date-label {
  background-color: var(--tambr-accent-color, #000000);
  color: #fff;
}

.dates-row .date-button.disabled {
  pointer-events: none;
  color: #d5d9de;
}

.dates-row .date-button .day-label {
  font-size: 10px;
  font-weight: 400;
  text-transform: uppercase;
  letter-spacing: 0.6px;
}

.dates-row .date-button .date-label {
  font-size: 13px;
  font-weight: 600;
  height: 25px;
  width: 25px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
}

.tambr-arrow-button {
  --arrow-button-size: 25px;
}

.dates-row .tambr-arrow-button {
  border: 0;
  --arrow-button-size: 35px;
}